const BaseURL = "https://api.aklighting19.com/"; // LIVE SITE
// const BaseURL = "https://staging.aklighting19.com/"; // TEST SITE
const ServerURL = BaseURL + "api/";
const api = {
  Login: ServerURL + "login",
  Register: ServerURL + "register",
  RegisterRequestOTP: ServerURL + "register/otp",
  getUserData: ServerURL + "user/profile/getuser",

  //Banner
  DashboardSlider: ServerURL + "slider/data",

  //Transfer
  Transfer: ServerURL + "user/wallet/transfer/credit",
  TransferUserDetails: ServerURL + "user/get-user-data",

  //Report
  EarningPointReport: ServerURL + "user/report/earning-points",
  CashPointReport: ServerURL + "user/report/cash-points",
  ConsumptionPointReport: ServerURL + "user/report/consumption-points",
  ProductVoucherReport: ServerURL + "user/report/product-voucher",
  RedemptionVoucherReport: ServerURL + "user/report/redemption-voucher",

  //Profile & Security
  LoginPassword: ServerURL + "user/profile/login-password",
  SecurityPassword: ServerURL + "user/profile/secure-password",
  PasswordChangeOTP: ServerURL + "reset-password/otp/send",
  ProfileEdit: ServerURL + "user/profile/update",
  MobileUpdateRequestOTP: ServerURL + "user/profile/update/otp",
  ProfilePictureUpload: ServerURL + "user/profile/pic/update",
  
  //Withdrawal
  Withdrawal: ServerURL + "user/withdraw/do",
  WithdrawalReport: ServerURL + "user/withdraw/report/data",

  //Purchase Cash Point
  CashPointPurchase: ServerURL + "user/wallet/purchase/credit",
  CashPointPurchaseReport: ServerURL + "user/wallet/purchase/credit/report",

  //Convert
  ProductVoucherConvert: ServerURL + "user/wallet/convert/credit/save",

  //Bank Details
  BankDetailsAdd: ServerURL + "user/withdraw/credit/bank/add",
  BankReport: ServerURL + "user/withdraw/credit/bank/get-all",
  BankDelete: ServerURL + "user/withdraw/credit/bank/delete",
  BankDefault: ServerURL + "user/withdraw/credit/bank/set-default",
  BankEdit: ServerURL + "user/withdraw/credit/bank/edit",
  DefaultBankDetails: ServerURL + "user/withdraw/credit/bank/get-default",

  //App Update and Version
  iosApp:"https://itunes.apple.com/WebObjects/MZStore.woa/wa/viewSoftware?id=1491586519",
  androidApp: "https://play.google.com/store/apps/details?id=com.rk.aklight",
  AndroidVersionPublic: ServerURL + "app/version/android",
  IOSVersionPublic: ServerURL + "app/version/ios",

  //Sponsor List
  SponsorList: ServerURL + "user/tree/referral",

  //Inbox
  InboxList: ServerURL + "user/inbox",
  AllReadInbox: ServerURL + "user/inbox/mark-as-read-all",
  InboxImage: BaseURL + "memo/",

  //Package
  PackageBuy: ServerURL + "user/package/purchase",
  PackageBuyReport: ServerURL + "user/package/purchase/report/data",

  //ForgetPassword
  ForgetPasswordOTP: ServerURL + "forgot-password/otp",
  ResetPassword: ServerURL + "forgot-password",

  //QR
  QRURL: BaseURL + "qr/qr.php?data=",
  RegisterQR: BaseURL + "register?ref=",
  lesePaymentMode: ServerURL + "user/my-account/order/payment",

  //Installer
  InstallerList: ServerURL + "user/installer/all",
  MyInstallerList: ServerURL + "user/installer/my",
  InstallerApply: ServerURL + "user/installer/apply",
  InstallerApplyCheck: ServerURL + "user/installer/can-apply",
  InstallerAddComment: ServerURL + "user/installer/comment",
  InstallerSingle: ServerURL + "user/installer/show/",
  InstallerCommentList: ServerURL + "user/installer/show/comments/",
  Cities: ServerURL + "user/cities",

  CommentPicURL: BaseURL + "pic/",
  MemoURL: BaseURL + "memo/",

  PointsHistory: ServerURL + "user/report/points",
  PurchaseHistory: ServerURL + "user/purchase/item",
  PurchaseSingle: ServerURL + "user/purchase/item/",
  InvoiceList: ServerURL + "user/purchase/invoice-list",

  //Mall
  CategoryList: ServerURL + "shopping/category",
  CategoryProductsList: ServerURL + "shopping/category/products",
  PromotionData: ServerURL + "promotion-product/data",
  ProductDetails: ServerURL + "shopping/product/",
  
  Helpline:"whatsapp://send?text=hello&phone=+60128732928",
  locationMap:"geo:1.4990499,110.3698735?q=A.K.+Lighting+Company",
  IOSMap:"https://maps.google.com/?q=A.K.+Lighting+Company&sll=1.4990499,110.3698735",
  FBUrl:"https://www.facebook.com/AK-Lighting-112751846773318/",

  //Location
  Outlets: ServerURL + "outlets",
};
export default api;
